module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_3.36d52415.png";